export default __webpack_public_path__ + "static/media/start-mining.275a6284.svg";